// src/index.tsx
import React from 'react';
import { createRoot } from 'react-dom/client'; // Import createRoot
import { BrowserRouter } from 'react-router-dom';
import 'reflect-metadata';

import App from './pages/App';
import reportWebVitals from './reportWebVitals';
import './styles/raster.grid.css';
import './styles/raster-override.css';

const container = document.getElementById('root');

if (!container) throw new Error("Failed to find the root element");

const root = createRoot(container);

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);

reportWebVitals();